import { asset } from "./assets";

// Not exported: nothing outside this module needs the photo shape by name,
// only the album shape it composes (fallow's dead-code check flags an
// exported type with no importer).
interface GalleryPhoto {
  src: string;
  alt: string;
}

/** The three gallery album slugs, matching `public/_redirects` targets. */
export type AlbumSlug =
  | "lifestyle-fair-2022"
  | "meet-greet-meditate-share-2022"
  | "old-photos";

// Not exported: nothing outside this module needs the per-album shape,
// only the assembled `ALBUMS` value below (fallow's dead-code check flags
// an exported type with no importer, even one used only via `satisfies`
// in the same file).
/** A re-encoded album video and the poster frame shown before it plays. */
interface AlbumVideo {
  src: string;
  poster: string;
  label: string;
}

interface Album {
  slug: AlbumSlug;
  title: string;
  cover: GalleryPhoto;
  photos: readonly GalleryPhoto[];
  /** Only the Lifestyle Fair album had video coverage. */
  videos: readonly AlbumVideo[];
}

/**
 * `/gallery/lifestyle-fair-2022`: every photograph from the old site's
 * `/lifestyle-fair-2022-aug` album, in the page's own order (its masonry
 * grid, then its tile grid). The old site carried no real per-photo
 * captions here (a stray " - Copy" alt on a few images, empty on the
 * rest), so each photo gets a numbered descriptive alt instead. One pair
 * of photos repeats (photo 51 and photo 57) - that duplication is on the
 * old site itself, kept verbatim. The album's 25 videos were not fetched
 * (deferred to R2, see plan D); `AlbumPage` shows a coming-soon line for
 * this album only.
 */
const LIFESTYLE_FAIR_PHOTOS: readonly GalleryPhoto[] = [
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/a1d92356b76b42e1a289b85f3ebf26dc.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 1",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/cb3d358196024991a7e0523a6748fb73.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 2",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/0467ad7d81794bfe8af710dc46ee89ca.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 3",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/b82631251eb54331b0afe1a2fcbbefe8.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 4",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/d6f67d54dc4942cba2b040ee3c9137d4.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 5",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/8866500aeb3d4e5db12fe218eae8d14e.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 6",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/c9b4ee71218547c39666985be1076515.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 7",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/390a53c08b9d423abab19d3f49f7fc42.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 8",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/486884944d9e49399c5172ca29c45dba.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 9",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/a8d1635aace34039a451b9188ecfaadc.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 10",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/44c9c19907204f98895a6fcf91cdc200.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 11",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/84d7f4d25b9d4b90a6b8c9da34111faa.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 12",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/a9dbe6631bc2406ea6bc370b77cf5728.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 13",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/b9caf17df5824cfea777eaaf7e147751.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 14",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/f34d1aa71e4d41edac55300d2b3776e0.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 15",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/12b7db742cbf4ddeb0d0fd6bc5555c60.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 16",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/70333c4e5c3845ee93fba76d743baf1b.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 17",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/89076886b05c4b5d95b78f9cc87d9691.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 18",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/6661fee08a1a470f823439d90866c0e6.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 19",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/ad82cb2f0bfb454fb42955405c4d3c41.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 20",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/bce9200abf7e443f9c2f3aeeb1750e84.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 21",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/778602c5241645d498fdff5c6aeac0c6.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 22",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/bfd4891118eb4ad6b1e35c42db544e41.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 23",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/167/3e9e08e3da3d4bccb55d233515360a92.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 24",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6f583e3dabb94da2b33529de6544d2df.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 25",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/cca93c5f0eea45ca91c1e60f0d41ff60.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 26",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/471ef212eeb1411e9e7d8886b9fa2918.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 27",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/83ac1d9eea0b4b31a2a3be9547e3a5cc.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 28",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/87e3775dd95d412fa548c0969d778ee7.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 29",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/4a59434963f249c1b87f7b7a237a8bcb.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 30",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/245f8a46e98d4b528706a8dbfee552ee.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 31",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ae49730624aa499cbb7be625422002ef.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 32",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/20759260176b46979700db906d93d51b.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 33",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ffa2265f25a44efe8abd3d47c0830c02.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 34",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/03ae691e81e7428ea9bf188273b1f4f0.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 35",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/3636742fe6274e6b9d1e7e0e0d86effc.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 36",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e37f4ee33acd4ca0908b2f80a2e273df.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 37",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ab78100b18954f8aaa15178240a44b08.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 38",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/0414eb6074b44a4e9831872e13cb95d3.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 39",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/df5f8e8bcbd54398aad08afc367e0558.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 40",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/64a4d28705f24d48bf6819d330c9c7b4.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 41",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b0c03401679d4724b75c47ba2f4bbc7a.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 42",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b893d1d9e7594c65aabf0dd0f54ebe7a.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 43",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e9d9d193025649b9b4fbe3b79010592b.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 44",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/de90f730b3ba491cb2c1f3954ca75d1c.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 45",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/d9db33d097a444e0802e0a8708928b9e.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 46",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6d80734917324aaeb148b209b0318086.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 47",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e10005d26fe24b829f1f89b96c235141.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 48",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/1fa17e423bba4b84969af94cf41f7a37.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 49",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/4635f0917b1f424699746fbe576b7747.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 50",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/998e359d89ee4511b60ac458a8c3423f.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 51",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e2d06720ae12423d86983a598c85ad49.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 52",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/1a6cac0340c641bbbcb5cdfd07de834e.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 53",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6f31a47ee5f04f92a62233309239dce2.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 54",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ffc76b4ddb1c42bfa0d6cf360efbd4cd.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 55",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6f27e384d84945b88e36bc876fc52c97.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 56",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/998e359d89ee4511b60ac458a8c3423f.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 57",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/69f45608656640d0ae319bcc5a23ba1e.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 58",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/463259f967c24848a5c4f1302007f7c9.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 59",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/369e7b96ed5e405c815cdfb4a459e8d5.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 60",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b85639ebb1ca4a41aef00e14d73bf17f.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 61",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/4f3f3e17e6924eb4af6b64142f57a952.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 62",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/da6cc9fd3c024424a7e3b2bab1eec8fd.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 63",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/6ccbcc874a0044dba1cde18d19b4773f.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 64",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/ec822d2e6bdc4dd4ab1d92c8789da4b0.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 65",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/cc359e3ff29c4d14a747f980987c3128.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 66",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/23bc00ac02b145b4b06e1388a66f33a9.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 67",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b541ed15bf5746a585356e296c69846b.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 68",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/1daff67ce1394398847eb6ce0b55b973.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 69",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/d7c6d8387bfc47dba5774b5554ebbca4.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 70",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/1736a794029f4a3ab916b09c43fbbe4e.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 71",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/a005160f78fb41349117a037ea3754d1.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 72",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/69a026ec569648ac894dfc18595c57ed.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 73",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/a6a567b0773f40e295265cd6a312e987.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 74",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/21c48069f6e844fabc7d39bdcf978329.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 75",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/c2054cc3794f45cab407c4b5833579e8.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 76",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/c8f2f695eace4cd3bf9844f5e5e3b53d.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 77",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/b0cf168617d34d58b74b127ddc25ca82.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 78",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/26b9563b45b941b0b0305b6902f0f09e.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 79",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/46fa5635c0aa44a193a59aa915a27235.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 80",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/aaf15cc826b543eb8eef491dec51f7a7.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 81",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/81cc640ca9364a71aecc4bca205fe99d.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 82",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/a52d3dd4962a4174b5a3ef5f8eb84afd.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 83",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/aef3b46c0016408bbaea57a216bbf8ba.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 84",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/a4982d2b55174772977b94f1239f90a2.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 85",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/85124a75d62941feb3fabfd74414438a.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 86",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/e802ca8f682a41b79507f74f6b1d9960.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 87",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/48fa7d2a425e473f836235b9b7415d59.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 88",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/4f699abba89f431d84179ab83890c98b.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 89",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/480/5c7d3880f8ef4ae8a5dd11301d64062c.jpg?v=250703010154",
    ),
    alt: "Lifestyle Fair 2022, photo 90",
  },
];

/**
 * `/gallery/meet-greet-meditate-share-2022`: every photograph from the old
 * site's `/meet-greet-meditate-share-2022-jun` album, in the page's own
 * order (its two masonry grids back to back). No real per-photo captions
 * on the old site, so each photo gets a numbered descriptive alt.
 */
const MEET_GREET_PHOTOS: readonly GalleryPhoto[] = [
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/1511e1fee1c04250aa2a3e21d6a5cc01.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 1",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/47e97817b1c745e4ac18abb3457a19cb.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 2",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/449bc87b61444b43988b8190de3084bd.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 3",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/b83eb2f3acd64ecc9af7534623535243.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 4",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/6148ae3f233b4f01a45dcb9dd22e9fdc.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 5",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/00394aeb93614191bffe5546ddc7c940.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 6",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/cd97826f7f414ae98708e41b2355fed9.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 7",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/d6d4ad4b31cf4d2f83ada2961aca5a4a.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 8",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/56942b42ead146f49bfcbbfd9119d330.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 9",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/b9aa17b5a5354a7cafb273bab7e07729.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 10",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/87b74c2f1b3141bd9fec49261ff86953.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 11",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/502d22328dc7408a92b9fde9854d8419.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 12",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/691c24b4ec924c22a8edf4d2518d87e2.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 13",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/5ae7beb3142340669e72c210f364836f.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 14",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/be7c748ae8f64172a28da99c5740b173.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 15",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/b993a1ed6c9d40e8a8043926ca21aa97.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 16",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/b70c52ac19a149b6aef86bc474d35342.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 17",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/7d0a2db2dcb347a38175d284849cd750.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 18",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/aef00cc87c1b45f982aee572b54ba451.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 19",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/8a59e55176824556b0f62ac1346a3e76.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 20",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/91403019073048d1a21b3e2ba146a7df.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 21",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/8d8c054cf2144ce88d71e5cf853a9ea1.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 22",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/9e58cf98682e4d108da18d0ab84b7eaa.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 23",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/3bd98769a0bf4458a5b8c6ba7aeb608d.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 24",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/208/797d62d8a8544c2baa23dec73528ec83.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 25",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/64513fad5c4e478bbc61f8cc6e29bc91.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 26",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/47cc57ed9b514ce2bb783666b1633cb4.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 27",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/37800c5479144e8884e07c3c7127a6e5.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 28",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/e66e268a55584048af774e822a0dd640.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 29",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/d4defa8ce195444b9c585bec8d55ad6f.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 30",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/ba45b9fba88743399101ba9410f9cd87.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 31",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/439125b625d7432ca10d88364f32b6ff.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 32",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/92cf7bb159bd49b3a0d9a32fb69e85e2.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 33",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/2a60e601f97e4a6a8f69c34e2219312e.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 34",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/5a55da243b4540149e06ffc5a0bf64e0.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 35",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/89460d1756f2494e93b341aeb5ca1944.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 36",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/190/70bd109c4e9647f2b5ee6671b4bd35de.jpg?v=250703010154",
    ),
    alt: "Meet-Greet-Meditate-Share 2022, photo 37",
  },
];

/**
 * `/gallery/old-photos`: every photograph from the old site's
 * `/old-photos` album, grouped under its own two verbatim section
 * headings ("Swamiji in Singapore - 2016", then "Stalls @GJ"). A third
 * heading on the old page ("International Day of Yoga @CSC Changi") had
 * no photos under it on the live site, so it contributes nothing here.
 */
const OLD_PHOTOS_PHOTOS: readonly GalleryPhoto[] = [
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/9203A94C1D87A5AB.jpg?v=250703010154",
    ),
    alt: "Swamiji in Singapore - 2016, photo 1",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/73DB5DA183E3E349.jpg?v=250703010154",
    ),
    alt: "Swamiji in Singapore - 2016, photo 2",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/5043C9491BF736FA.jpg?v=250703010154",
    ),
    alt: "Swamiji in Singapore - 2016, photo 3",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/986567C21B9D4BE9.jpg?v=250703010154",
    ),
    alt: "Swamiji in Singapore - 2016, photo 4",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/6C95C511A1B0A56F.jpg?v=250703010154",
    ),
    alt: "Swamiji in Singapore - 2016, photo 5",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/309/3923B236D387DF13.jpg?v=250703010154",
    ),
    alt: "Swamiji in Singapore - 2016, photo 6",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/FC52664210011F8D.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 1",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/035AC0428128C5D3.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 2",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/7176694C9D7D6E35.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 3",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/D93445FA7ED53684.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 4",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/A52035FFA5D1694A.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 5",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/E99A58F68BB80062.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 6",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/D83A0704964F0D26.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 7",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/ECD86FBDE56042F5.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 8",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/D38A48F4A1717366.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 9",
  },
  {
    src: asset(
      "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/324/FAAAD794879B944C.jpg?v=250703010154",
    ),
    alt: "Stalls @GJ, photo 10",
  },
];

/**
 * `/gallery`: the three photo albums from the old site's `/galary` page,
 * cover images and titles verbatim from its album-picker carousel. The
 * old site's `-HI` pages carried the exact same English titles and
 * captions for every one of these four pages (no distinct Hindi copy),
 * so nothing here needs a `hi` twin - an `/hi/gallery/...` visitor sees
 * the same English text the old site itself showed them.
 */
/**
 * `/gallery/lifestyle-fair-2022`: the album's 21 video highlights. The old
 * site served these as raw multi-megabyte MP4s straight off its CDN; each
 * one here is re-encoded for the web and paired with a poster frame so the
 * grid costs nothing until a visitor presses play.
 */
const LIFESTYLE_FAIR_VIDEOS: readonly AlbumVideo[] = [
  {
    src: "/video/0255e9fb9c7541498d9626e4de4c7c7c.mp4",
    poster: "/video/0255e9fb9c7541498d9626e4de4c7c7c.jpg",
    label: "Lifestyle Fair 2022 highlight 1",
  },
  {
    src: "/video/07aec4740cda4a64a291344f48e8cef4.mp4",
    poster: "/video/07aec4740cda4a64a291344f48e8cef4.jpg",
    label: "Lifestyle Fair 2022 highlight 2",
  },
  {
    src: "/video/16a81b2fb3a04aa7ac6f44c23b6d7149.mp4",
    poster: "/video/16a81b2fb3a04aa7ac6f44c23b6d7149.jpg",
    label: "Lifestyle Fair 2022 highlight 3",
  },
  {
    src: "/video/1a45a1f207de48bfa600076026d97f53.mp4",
    poster: "/video/1a45a1f207de48bfa600076026d97f53.jpg",
    label: "Lifestyle Fair 2022 highlight 4",
  },
  {
    src: "/video/1fd73a85b22a4e6baee5b1815dae32a2.mp4",
    poster: "/video/1fd73a85b22a4e6baee5b1815dae32a2.jpg",
    label: "Lifestyle Fair 2022 highlight 5",
  },
  {
    src: "/video/28835c5f98514061b1cfe92cdf335cfa.mp4",
    poster: "/video/28835c5f98514061b1cfe92cdf335cfa.jpg",
    label: "Lifestyle Fair 2022 highlight 6",
  },
  {
    src: "/video/465eacf603f84f548541b6ccbf30a773.mp4",
    poster: "/video/465eacf603f84f548541b6ccbf30a773.jpg",
    label: "Lifestyle Fair 2022 highlight 7",
  },
  {
    src: "/video/6106646d77234984b9efcd7f5ae6af54.mp4",
    poster: "/video/6106646d77234984b9efcd7f5ae6af54.jpg",
    label: "Lifestyle Fair 2022 highlight 8",
  },
  {
    src: "/video/62acbf763ef04a258582d15d0c8a7cb4.mp4",
    poster: "/video/62acbf763ef04a258582d15d0c8a7cb4.jpg",
    label: "Lifestyle Fair 2022 highlight 9",
  },
  {
    src: "/video/98de2e3c0dd7489ead6f29633e0c66a5.mp4",
    poster: "/video/98de2e3c0dd7489ead6f29633e0c66a5.jpg",
    label: "Lifestyle Fair 2022 highlight 10",
  },
  {
    src: "/video/a478a03b8e7e4167b90b342e7e1a8eeb.mp4",
    poster: "/video/a478a03b8e7e4167b90b342e7e1a8eeb.jpg",
    label: "Lifestyle Fair 2022 highlight 11",
  },
  {
    src: "/video/b514905e9b974a99b11b3c19825802c5.mp4",
    poster: "/video/b514905e9b974a99b11b3c19825802c5.jpg",
    label: "Lifestyle Fair 2022 highlight 12",
  },
  {
    src: "/video/bc72f011a10e40829c8baf0e0fbc943b.mp4",
    poster: "/video/bc72f011a10e40829c8baf0e0fbc943b.jpg",
    label: "Lifestyle Fair 2022 highlight 13",
  },
  {
    src: "/video/bcf5571ad4b6428c8febb82425c6eb80.mp4",
    poster: "/video/bcf5571ad4b6428c8febb82425c6eb80.jpg",
    label: "Lifestyle Fair 2022 highlight 14",
  },
  {
    src: "/video/cd04afe60b3b49599aaa280d75bea977.mp4",
    poster: "/video/cd04afe60b3b49599aaa280d75bea977.jpg",
    label: "Lifestyle Fair 2022 highlight 15",
  },
  {
    src: "/video/d16695922b8c44e9b9f790ce23f4beb5.mp4",
    poster: "/video/d16695922b8c44e9b9f790ce23f4beb5.jpg",
    label: "Lifestyle Fair 2022 highlight 16",
  },
  {
    src: "/video/d38d88347d95449f81199b60e6fd4753.mp4",
    poster: "/video/d38d88347d95449f81199b60e6fd4753.jpg",
    label: "Lifestyle Fair 2022 highlight 17",
  },
  {
    src: "/video/e1b0077a0d1d4c59a419bcad978afb10.mp4",
    poster: "/video/e1b0077a0d1d4c59a419bcad978afb10.jpg",
    label: "Lifestyle Fair 2022 highlight 18",
  },
  {
    src: "/video/e7a79acf99c148ca99b02917670c84cc.mp4",
    poster: "/video/e7a79acf99c148ca99b02917670c84cc.jpg",
    label: "Lifestyle Fair 2022 highlight 19",
  },
  {
    src: "/video/e9fb85a1ab5348bda9946f4756c61a59.mp4",
    poster: "/video/e9fb85a1ab5348bda9946f4756c61a59.jpg",
    label: "Lifestyle Fair 2022 highlight 20",
  },
  {
    src: "/video/f8401b14dfcf4fbb9b6940fa948e54ff.mp4",
    poster: "/video/f8401b14dfcf4fbb9b6940fa948e54ff.jpg",
    label: "Lifestyle Fair 2022 highlight 21",
  },
];

export const ALBUMS = {
  "lifestyle-fair-2022": {
    slug: "lifestyle-fair-2022",
    title: "Lifestyle Fair 2022 Aug",
    cover: {
      src: asset(
        "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/24b187cdb1d94461830f567c8452e0a3.jpg?v=250703010154",
      ),
      alt: "Lifestyle Fair 2022 Aug",
    },
    photos: LIFESTYLE_FAIR_PHOTOS,
    videos: LIFESTYLE_FAIR_VIDEOS,
  },
  "meet-greet-meditate-share-2022": {
    slug: "meet-greet-meditate-share-2022",
    title: "Meet-Greet-Meditate-Share 2022 Jun",
    cover: {
      src: asset(
        "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/acece4f0cfa54979a86f048847277555.jpg?v=250703010154",
      ),
      alt: "Meet-Greet-Meditate-Share 2022 Jun",
    },
    photos: MEET_GREET_PHOTOS,
    videos: [],
  },
  "old-photos": {
    slug: "old-photos",
    title: "Old Photos",
    cover: {
      src: asset(
        "https://site-hjx4qqt6.wsecdn1.websitecdn.com/uploads/768/75200e940ada46d8ab07631027f780a8.jpg?v=250703010154",
      ),
      alt: "Old Photos",
    },
    photos: OLD_PHOTOS_PHOTOS,
    videos: [],
  },
} satisfies Record<AlbumSlug, Album>;

/** True narrowing for a router-matched slug, so callers never need `as`. */
export function isAlbumSlug(value: string): value is AlbumSlug {
  return Object.hasOwn(ALBUMS, value);
}
